import React from 'react';

import {
	getLivePageReleasePhase,
	LivePageReleasePhase,
} from '@confluence/live-pages-utils/entry-points/isLivePagesFeatureEnabled';
import { useIsProductAdmin } from '@confluence/current-user';

import { LivePagesOpenBetaPromptModalLoader } from './LivePagesOpenBetaPromptModalLoader';

export const LivePagesOpenBetaPromptModalWrapper = () => {
	const livePageReleasePhase = getLivePageReleasePhase();
	const { isProductAdmin } = useIsProductAdmin();

	// only checks if modal passes basic conditions to be shown, does not check coordination with choreographer
	const showModal =
		isProductAdmin && // product admin
		livePageReleasePhase === LivePageReleasePhase.OPEN_BETA_INITIAL; // in open beta and has not opted in yet

	return <>{showModal ? <LivePagesOpenBetaPromptModalLoader /> : null}</>;
};
